import { ListBasketInsightSort } from '@epicuro-next/data/reporting-api';

export const basketInsightSortOptions = [
  {
    key: ListBasketInsightSort.MostRevenue,
    displayName: $localize`:Analytics|Basket Insight sort revenue@@analyticsBasketInsightSortRevenue:Revenue`,
  },
  {
    key: ListBasketInsightSort.MostRecent,
    displayName: $localize`:Analytics|Basket Insight sort most recent@@analyticsBasketInsightSortMostRecent:Most Recent`,
  },
  {
    key: ListBasketInsightSort.Quantity,
    displayName: $localize`:Analytics|Basket Insight sort quantity@@analyticsBasketInsightSortQuantity:Quantity`,
  },
];

export type BasketInsightSortOption = typeof basketInsightSortOptions[0];
